import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcImproveHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 22,
	viewBox: "0 0 19 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.8937 6.82812C13.3127 6.82812 13.6523 7.16777 13.6523 7.58674L13.6523 21.2418C13.6523 21.6608 13.3127 22.0004 12.8937 22.0004L5.30757 22.0004C4.88859 22.0004 4.54895 21.6608 4.54895 21.2418L4.54895 7.58674C4.54895 7.16777 4.88859 6.82812 5.30757 6.82812L12.8937 6.82812Z",
		fill: "#415E96"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.59152 0.53445C8.88829 0.239183 9.36814 0.240124 9.66375 0.536555L16.914 7.807C17.3912 8.28551 17.0517 9.10207 16.376 9.1013L1.83506 9.08463C1.1587 9.08386 0.8214 8.26528 1.30087 7.78823L8.59152 0.53445Z",
		fill: "#415E96"
	})]
});
export default SvgIcImproveHome;
